module.exports = __webpack_public_path__ + "fonts/War is Over.9b2a1654.ttf";